import React, { useMemo } from 'react'
import { useLabels } from 'src/pages/AccountSettings/AccountSettings.hooks'
import { LabelsContext } from './labelMap'

export { LabelsContext, labelNamesForSearch, useLabelMap } from './labelMap'

export const LabelsProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const { data: labelsData } = useLabels()
  const labelMap = useMemo(() => {
    const map: Record<string, string> = {}
    labelsData?.getItemsList().forEach((label) => {
      map[label.getId()] = label.getName()
    })
    return map
  }, [labelsData])

  return (
    <LabelsContext.Provider value={labelMap}>{children}</LabelsContext.Provider>
  )
}
